module.exports = __webpack_public_path__ + "img/5.cff5816d.png";